export const SEARCH_QUERY = `
  query searchQuery(
    $searchString: String
    $searchCategory: String
    $first: Int
    $after: ElementWhereUniqueInput
    $orderBy: [ElementOrderByInput!]
  ) {
    elements(
      where: {
        iblock: { code: { equals: $searchCategory } },
        propertyValues: { none: { value: { contains: "noindex, nofollow"} } }
        AND: [
          {
            propertyValuesEnum: {
              none: { property: { OR: [{ code: { equals: "hiddenPage" } }, { code: { equals: "uniquePages" } } ] } }
            }
          }
          {
            OR: [
              {
                AND: [
                  { name: { contains: $searchString } }
                  { iblock: { code: { equals: $searchCategory } } }
                ]
              }
              {
                AND: [
                  {
                    propertyValues: {
                      some: { value: { contains: $searchString } }
                    }
                  }
                  {
                    iblock: {
                      OR: [
                        { code: { equals: "document" } }
                        { code: { equals: "rgs_news" } }
                      ]
                    }
                  }
                ]
              }
              {
                propertyValuesRelation: {
                  some: {
                    targetElement: {
                      AND: [
                        { iblock: { code: { equals: "sectionProductHero" } } }
                        {
                          propertyValues: {
                            some: { value: { contains: $searchString } }
                          }
                        }
                      ]
                    }
                  }
                }
              }
            ]
          }
        ]
      }
      first: $first
      after: $after
      orderBy: $orderBy
    ) {
      id
      name
      activeFrom
      active
      code
      iblock {
        code
      }
      seo {
        elementPageTitle
        elementMetaDescription
      }
      propertyValues {
        property {
          code
        }
        value
      }
      propertyValuesRelation(
        where: {
          OR: [
            { property: { type: FILE } }
            {
              targetElement: {
                iblock: { code: { equals: "sectionProductHero" } }
              }
            }
          ]
        }
      ) {
        property {
          code
          type
          kind
        }
        targetFile {
          url
          size
          contentType
        }
        targetElement {
          iblock {
            name
            id
            code
          }
          propertyValues(where: { property: { code: { equals: "text" } } }) {
            value
          }
        }
      }
    }
    elementsCount(
      where: {
        iblock: { code: { equals: $searchCategory } }
        propertyValues: { none: { value: { contains: "noindex, nofollow"} } }
        AND: [
          {
            propertyValuesEnum: {
              none: { property: { OR: [{ code: { equals: "hiddenPage" } }, { code: { equals: "uniquePages" } } ] } }
            }
          }
          {
            OR: [
              {
                AND: [
                  { name: { contains: $searchString } }
                  { iblock: { code: { equals: $searchCategory } } }
                ]
              }
              {
                AND: [
                  {
                    propertyValues: {
                      some: { value: { contains: $searchString } }
                    }
                  }
                  {
                    iblock: {
                      OR: [
                        { code: { equals: "document" } }
                        { code: { equals: "rgs_news" } }
                      ]
                    }
                  }
                ]
              }
              {
                propertyValuesRelation: {
                  some: {
                    targetElement: {
                      AND: [
                        { iblock: { code: { equals: "sectionProductHero" } } }
                        {
                          propertyValues: {
                            some: { value: { contains: $searchString } }
                          }
                        }
                      ]
                    }
                  }
                }
              }
            ]
          }
        ]
      }
    )
  }
`

export const TEST_QUESTION_QUERY = `
  query testQuestion($where: ElementWhereInput) {
    elements(where: $where) {
      id
      name
      iblock {
        code
      }
      activeFrom
      sort
      code
      propertyValues {
        property {
          code
        }
        value
      }
      propertyValuesEnum {
        property {
          code
        }
        value
      }
      propertyValuesRelation {
        property {
          code
        }
        id
        targetElement {
          iblock {
            code
          }
          activeFrom
          sort
          code
          id
          name
          propertyValues {
            property {
              code
            }
            value
          }
          propertyValuesEnum {
            property {
              code
            }
            value
          }
          propertyValuesRelation {
            property {
              code
            }
            targetElement {
              iblock {
                code
              }
              activeFrom
              sort
              code
              id
              name
              propertyValues {
                property {
                  code
                }
                value
              }
              propertyValuesEnum {
                property {
                  code
                }
                value
              }
              propertyValuesRelation {
                property {
                  code
                }
                targetElement {
                  id
                  name
                  iblock {
                    code
                  }
                  activeFrom
                  sort
                  code
                  propertyValuesEnum {
                    property {
                      code
                    }
                    value
                  }
                  propertyValues {
                    property {
                      code
                    }
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export const DATA_STAT_AGENTOM_QUERY = `
  query statAgentomExcludesRegions {
    statAgentomExcludesRegions: elements(
      where: { iblock: { code: { equals: "statAgentomExcludesRegions" } } }
    ) {
      name
      propertyValues {
        property {
          code
        }
        value
      }
    }
  }
`

export const NEWS_QUERY = `
  query newsQuery(
    $after: ElementWhereUniqueInput
    $orderBy: [ElementOrderByInput!]
    $searchString: String
    $first: Int
    $codeNews: String
    $tagsSearch: PropertyRelationListRelationFilter
    $notId: String
  ) {
    elements(
      where: {
        iblock: { code: { equals: "rgs_news" } }
        id: { not: { equals: $notId } }
        propertyValues: { some: { value: { contains: $searchString } } }
        propertyValuesRelation: $tagsSearch
        code: { equals: $codeNews }
      }
      first: $first
      after: $after
      orderBy: $orderBy
    ) {
      id
      name
      activeFrom
      code
      seo {
        elementPageTitle
        elementMetaDescription
      }
      ...news_properyValues
      ...news_propertyValuesEnum
      ...news_propertyValuesRelation
    }
    elementsCount(where: { iblock: { code: { equals: "rgs_news" } } })
  }

  fragment news_properyValues on Element {
    propertyValues {
      property {
        code
      }
      value
    }
  }

  fragment news_propertyValuesRelation on Element {
    propertyValuesRelation {
      property {
        code
        type
        kind
      }
      targetFile {
        url
        size
        contentType
      }
      targetElement {
        iblock {
          code
        }
        sort
        code
        name
        id
        ...news_properyValues
        ...news_propertyValuesEnum
        ...news_relationLvl_2
      }
    }
  }

  fragment news_propertyValuesEnum on Element {
    propertyValuesEnum {
      property {
        code
      }
      value
    }
  }

  fragment news_relationLvl_2 on Element {
    propertyValuesRelation {
      property {
        code
        type
        kind
      }
      targetFile {
        url
        size
        contentType
      }
      targetElement {
        iblock {
          code
        }
        sort
        code
        name
        id
        ...news_properyValues
        ...news_propertyValuesEnum
        ...news_relationLvl_3
      }
    }
  }

  fragment news_relationLvl_3 on Element {
    propertyValuesRelation {
      property {
        code
        type
        kind
      }
      targetFile {
        url
        size
        contentType
      }
      targetElement {
        iblock {
          code
        }
        sort
        code
        name
        id
        propertyValues {
          property {
            code
          }
          value
        }
        ...news_reletionLvl_4
        ...news_propertyValuesEnum
      }
    }
  }

  fragment news_reletionLvl_4 on Element {
    propertyValuesRelation {
      property {
        code
        type
        kind
      }
      targetFile {
        url
        size
        contentType
      }
      targetElement {
        iblock {
          code
        }
        sort
        code
        name
        id
        propertyValues {
          property {
            code
          }
          value
        }
        ...news_relationLvl_5
        ...news_propertyValuesEnum
      }
    }
  }

  fragment news_relationLvl_5 on Element {
    propertyValuesRelation {
      property {
        code
        type
        kind
      }
      targetFile {
        url
        size
        contentType
      }
      targetElement {
        iblock {
          code
        }
        sort
        code
        name
        id
        propertyValues {
          property {
            code
          }
          value
        }
        ...news_propertyValuesEnum
      }
    }
  }
`

export const VACANCIES_QUERY = `
  query getVacancies($filter: ElementWhereInput, $first: Int) {
    elementsCount(where: $filter)
    elements(first: $first, where: $filter, orderBy: { createdAt: desc }) {
      name
      code
      createdAt
      propertyValues {
        value
        id
        property {
          name
          code
        }
      }
      propertyValuesRelation {
        property {
          code
        }
        targetElement {
          name
        }
      }
    }
  }
`

export const LISTS_VACANCY_FILTERS = `
  query listsVacancyFilters {
    specialties: elements(
      where: { iblock: { code: { equals: "vacancySpecializations" } } }
    ) {
      name
      id
    }
    regions: elements(
      where: { iblock: { code: { equals: "vacancyRegions" } } }
      orderBy: { name: asc }
    ) {
      name
      id
    }
  }
`

export const LISTS_REGION_APPEAL_QUERY = `
  query listsRegionsAppeal {
    regions: elements(
      where: { iblock: { code: { equals: "appealRegions" } } }
    ) {
      name
      propertyValues {
        property {
          code
        }
        value
      }
    }
  }
`

export const OFFICE_TYPE_INFO_QUERY = `
        query officeTypeInfo {
          info: elements(
            where: { iblock: { code: { equals: "officeTypeInfo" } } }
          ) {
            name

            propertyValues {
              property {
                code
              }
              value
            }
            ...propertyValuesRelation
            ...propertyValuesEnum
          }
        }

        fragment propertyValuesRelation on Element {
          propertyValuesRelation {
            property {
              code
              type
              kind
            }
            targetFile {
              url
              size
              contentType
            }
          }
        }
        fragment propertyValuesEnum on Element {
          propertyValuesEnum {
            property {
              code
            }
            value
          }
          activeFrom
          activeTo
        }
      `

export const LIST_REGIONS_APPEAL_QUERY = `
  query listsRegionsAppeal {
    regions: elements(
      where: { iblock: { code: { equals: "appealRegions" } } }
    ) {
      name
      propertyValues {
        property {
          code
        }
        value
      }
    }
  }
`
